/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { faker } from '@faker-js/faker/locale/en';
import { ENTITY_TYPES } from '../../../constants/Repository.constants';
import { RECOMMENDED_RUNTIME_IMAGE } from '../../../constants/RuntimeImage.constants';
import { Job } from '../Job';

export const createMockJob = (partialRecord: Partial<Job> = {}): Job => {
  const version = Array.from({ length: 3 })
    .map(() => faker.number.int())
    .join('.');
  return {
    name: faker.lorem.word(),
    description: faker.lorem.sentence(),
    type: ENTITY_TYPES.job,
    version: version,
    image: RECOMMENDED_RUNTIME_IMAGE,
    ...partialRecord,
  };
};

export const createMockJobs = (size?: number): Array<Job> => {
  const randomSize = size ?? faker.number.int({ max: 3, min: 1 });
  return Array.from({ length: randomSize }).map(() => createMockJob());
};
